/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

function Subtitle({ children, className = '' }) {
  return (
    <div className={`dtv-html5-c-detail-container__subtitle ${className}`}>
      {children}
    </div>
  );
}

Subtitle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default memo(Subtitle);
